import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { User } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const CoursesSection = () => {
  const [courses, setCourses] = useState([]);

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const res = await axios.get(`${API}/courses`);
        setCourses(res.data);
      } catch (err) {
        console.error('Failed to fetch courses:', err);
      }
    };
    fetchCourses();
  }, []);

  return (
    <section id="courses" className="section-padding" style={{
      background: '#0f0a1e',
    }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <h2 style={{
          textAlign: 'center',
          fontSize: 'clamp(32px, 4vw, 48px)',
          fontWeight: 700,

          marginBottom: '12px',
        }}>
          Featured <span style={{ color: '#00d4ff' }}>Courses</span>
        </h2>
        <p style={{
          textAlign: 'center',
          fontSize: '15px',
          color: '#b0adc0',
          marginBottom: '12px',
        }}>
          Expand your consciousness with our expertly curated spiritual programs.
        </p>
        <div className="section-divider" style={{ marginBottom: '50px' }} />

        {/* Courses Grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
          gap: '24px',
        }}>
          {courses.map((course) => (
            <div
              key={course.course_id}
              className="glass-card"
              style={{
                overflow: 'hidden',
                transition: 'transform 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease',
              }}
              onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-6px)'; }}
              onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; }}
            >
              {/* Image */}
              <div style={{ position: 'relative', overflow: 'hidden', height: '180px' }}>
                <img
                  src={course.image}
                  alt={course.title}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                  }}
                />
              </div>

              {/* Content */}
              <div style={{ padding: '20px', textAlign: 'center' }}>
                <h3 style={{
                  fontSize: '17px',
                  fontWeight: 700,
                  marginBottom: '10px',
                  color: '#ffffff',
                  lineHeight: 1.3,
                  textAlign: 'center',
                }}>
                  {course.title}
                </h3>
                <p style={{
                  fontSize: '13px',
                  color: '#b0adc0',
                  lineHeight: 1.6,
                  marginBottom: '16px',
                  textAlign: 'center',
                }}>
                  {course.description}
                </p>

                {/* Meta */}
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '14px',
                  fontSize: '12px',
                  color: '#8885a0',
                  marginBottom: '18px',
                }}>
                  <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                    <User size={13} /> {course.instructor}
                  </span>
                </div>

                {/* Enroll Now button — centered, beating */}
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <button
                    className="btn-primary-gradient course-enroll-beat"
                    data-testid={`course-enroll-${course.course_id}`}
                    onClick={() => { if (course.link) window.open(course.link, '_blank', 'noopener,noreferrer'); }}
                    disabled={!course.link}
                    style={{
                      fontSize: '14px',
                      padding: '12px 34px',
                      justifyContent: 'center',
                      cursor: course.link ? 'pointer' : 'not-allowed',
                      opacity: course.link ? 1 : 0.7,
                    }}
                  >
                    Enroll Now
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CoursesSection;
